import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

import { AppThunk, RootState } from '../../app/store'
import { Coordinates, POI, ZoneTypeEnum } from '../../shared/types'
import { postData } from '../../shared/api/api'
import {
  FetchNearbyPOIsAndMapResponse,
  FetchPOIByIdRequest,
  FetchPOIByIdResponse,
} from './types'
import { setActiveMapId } from '../maps/mapsSlice'
import { fetchMapById } from '../maps/mapsThunks'
import {
  setDossierDiscoveredIds,
  setDossierProgress,
} from '../dossier/dossierSlice'

// Payload type for fetchPOIById thunk

export const fetchPOIById = createAsyncThunk<
  FetchPOIByIdResponse,
  FetchPOIByIdRequest,
  { state: RootState }
>('poi/fetchPOIById', async (poiId, thunkAPI) => {
  const state = thunkAPI.getState()
  const { zone, user } = state
  const zoneId = zone?.data?.id

  if (!zoneId) {
    return thunkAPI.rejectWithValue(
      'Unable to fetch POIById. Missing zoneId from state.'
    )
  }

  const body = {
    userId: user?.profile?.uid,
  }

  try {
    const response = await postData<FetchPOIByIdResponse>(
      `/zones/${zoneId}/poi/${poiId}`,
      body
    )
    // Check for dossierProgression in response
    if (response.dossierProgression)
      thunkAPI.dispatch(setDossierProgress(response.dossierProgression))
    // Update discoveredIds
    if (response?.discoveredIds)
      thunkAPI.dispatch(setDossierDiscoveredIds(response.discoveredIds))
    // If this was the first time visiting this POI, refetch nearby POIs and map
    if (response?.firstVisit) {
      const coords = state?.userLocation?.coords
      if (coords) {
        console.log('I')

        thunkAPI.dispatch(fetchNearbyPOIsAndMap(coords))
      } else {
        console.warn(
          '⚠️ First visit detected, but cannot refresh nearby POIs — missing coordinates from state.'
        )
      }
    }

    return response
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.response?.data?.error || error.message || 'Unknown error'
    )
  }
})

// The same func/thunk as below, but this one uses: createAsyncThunk()
export const fetchNearbyPOIsAndMap = createAsyncThunk<
  FetchNearbyPOIsAndMapResponse,
  Coordinates,
  { state: RootState }
>('poi/fetchNearbyPOIsAndMap', async (coords, thunkAPI) => {
  const state = thunkAPI.getState()
  const { zone, user } = state
  const zoneId = zone?.data?.id
  if (!zoneId) {
    return thunkAPI.rejectWithValue('Missing zoneId from state')
  }
  const body = {
    ...coords,
    userId: user?.profile?.uid,
  }
  try {
    console.log('A')

    // const result = await postData<POIResponse>('/poi/radar', body)

    const result = await postData<FetchNearbyPOIsAndMapResponse>(
      `/zones/${zoneId}/poi/radar`,
      body
    )
    // set the active map id and map
    const mapId = result?.mapId
    if (mapId) {
      thunkAPI.dispatch(setActiveMapId(mapId))
      // if active map does not exist in state yet, fetch and store it
      const existingMap = thunkAPI.getState().maps.visitedMaps[mapId]
      if (!existingMap) {
        console.log('fetch map:', mapId)
        await thunkAPI.dispatch(fetchMapById(mapId))
      }
    }
    return result
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message)
  }
})

// The same func/thunk as above, but this one is manual. it needs to be located in the Slice to work. it give you more control
// Thunk to call /location and set nearby POIs
// export const fetchNearbyPOIsAndMap =
//   (coords: Coordinates): AppThunk =>
//   async (dispatch, getState) => {
//     const state = getState()

//     dispatch(setPOILoading())

//     try {
//       const body = {
//         ...coords,
//         zoneId: state?.zone?.data?.id,
//       }
//       const result = await postData('/poi/radar', body) // expects result.nearbyPOIs
//       dispatch(setPOIs(result.nearbyPOIs))
//       dispatch(setPOISuccess())
//     } catch (err: any) {
//       dispatch(setPOIError(err.response?.data || err.message))
//     }
//   }
